
export const faqs = [
    {
        category: 'Safety',
        question:'How safe are the adventures?',
        answer:'DGA takes every precaution to ensure the safety of every adventurer. However,no adventure is 100% safe so adventurers are required to be cautious and alert at all times.'
    },
    {
        category: 'Activities',
        question:"Are the activities beginner friendly?",
        answer:'Most adventures require no prior expertise but some require some form of knowledge or experience.'
    },
    {
        category: 'Interaction',
        question:" How interactive are the adventures?",
        answer:"Adventures are made to be as fun and as engaging as possible this posing a gateway for the open minded adventurer to interact and have friends. "
    },
    {
        category: 'Customization',
        question:"Can I have a tailor made tour?",
        answer:"Every adventurer is allowed to chose when and how they would like their adventure making every adventure single and unique."
    },
    {
        category: 'Booking',
        question:"Can I cancel my tour?",
        answer:"An adventurer is allowed to cancel their tour in writing up to two months prior to departure and will be refunded in full less your nonrefundable deposit. Cancellations made within 60 days of departure will be refunded 75%."
    }
]
